import { createEntityQuery } from '@packages/api-client';
import { NotificationSharedService } from '@wealthlane/api-services/wealthlane-notification-service';

const useQuery = createEntityQuery<number, void>({
  queryKey: ['getGetUnseenNotificationCountList'],
  queryFn: () =>
    NotificationSharedService.getApiNotificationApiAppNotificationUnseenNotificationsCount(),
  options: { staleTime: 1000 * 60 * 5 },
});

export function useUnseenNotificationCount(enabled = true) {
  return useQuery(undefined, { enabled });
}
